import { useCallback, useEffect, useRef } from 'react';
import { getScreenCacheRevision } from '../utils/localCache';

// A response belongs to one mounted screen, cache generation and request channel.
export default function useRequestGuard(cacheKey) {
    const state = useRef({ mounted: true, lifetime: 0, channels: new Map() });
    useEffect(() => {
        const current = state.current;
        current.mounted = true;
        return () => { current.mounted = false; current.lifetime++; };
    }, []);
    return useCallback((channel = 'main') => {
        const current = state.current;
        const sequence = (current.channels.get(channel) || 0) + 1;
        current.channels.set(channel, sequence);
        const lifetime = current.lifetime;
        const revision = getScreenCacheRevision(cacheKey);
        return () => current.mounted && current.lifetime === lifetime
            && current.channels.get(channel) === sequence
            && getScreenCacheRevision(cacheKey) === revision;
    }, [cacheKey]);
}
